import React, { createContext } from 'react'
import { usePersistState } from '../hooks/state'

// The context object, shared by the provider below and its readers.
// eslint-disable-next-line react-refresh/only-export-components
export const Context = createContext()

// The person's theme and language are not kept here: they live in the
// zehn_prefs cookie every module shares (@zehnmindai/embed's PrefsProvider,
// main.jsx), chosen in the install's top bar.
function GlobalContext({ children }) {
    const [viewMode, setViewMode] = usePersistState('docsViewMode', 'cards')

    return (
        <Context.Provider
            value={{
                viewMode,
                setViewMode,
            }}
        >
            {children}
        </Context.Provider>
    )
}

export default GlobalContext
